export const formatTextContentCopyText = text => text;
